// extracted by mini-css-extract-plugin
export var modal = "_layout-module--modal--3Bw1J";
export var modal_dialog = "_layout-module--modal_dialog--1qjqJ";
export var modal_close = "_layout-module--modal_close--2DHP1";
export var modal_container = "_layout-module--modal_container--1D-Pz";